var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SwitchGroupList.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-103115ed!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SwitchGroupList.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/switch-group/SwitchGroupList.vue
// module id = 954
// module chunks = 2